"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
class Triggerable {
  constructor() {
    this.actions = {};
    this.cache = {};
  }
  on(tag, action) {
    let runImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (typeof action === 'function') {
      this.actions[tag] = action;
    } else {
      throw new Error(`Callback for event ${tag} is not a function`);
    }
    if (runImmediately && Object.prototype.hasOwnProperty.call(this.cache, 'tag')) {
      action(this.cache[tag]);
    }
  }
  trigger(tag, payload, event) {
    const triggers = Object.keys(this.actions).filter(k => k.startsWith(tag));
    this.cache[tag] = payload;
    if (triggers.length === 0) return false;
    triggers.forEach(k => {
      this.actions[k](payload, event);
    });
    return true;
  }
  hasAction(tag) {
    const triggers = Object.keys(this.actions).filter(k => k.startsWith(tag));
    return triggers.length > 0;
  }
}
exports.default = Triggerable;